import { Observable } from "rxjs";
import { bufferCount, map } from "rxjs/operators";

export const takeEvery = <T>(every: number) => (
    input: Observable<T>
): Observable<T> =>
    input.pipe(
        bufferCount(every),
        map((buffer) => buffer[every - 1])
    );
